

















import Vue from "vue";
import Lightbox from "@/components/Lightbox.vue";

export default Vue.extend({
    components: {
        Lightbox,
    },

    data() {
        return {
            showImage: false,
        };
    },

    mounted() {
        window.setTimeout( () => {
            this.showImage = true;
        }, 500);
    },
});
